// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.domino {
  min-width: 150px;
  height: 60px;
  border-radius: 15px;
  border-width: 2px;
  border-style: solid;
  margin: 14px 0px;
}

.place-domino {
  background-color: #ededed;
  border-color: #cacaca;
}

.place-domino:hover {
  transform: none;
}

.some-domino {
  position: relative;

  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  border-color: #20677b;

  filter: drop-shadow(2px 2px 7px #adadad);

  font-size: 20px;
  font-family: "Manrope";
  font-weight: bold;
}

.some-domino-without-hover:hover {
  transform: none;
}
`, "",{"version":3,"sources":["webpack://./src/Components/StyledComponents/DominoButton.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;;EAElB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;;EAErB,wCAAwC;;EAExC,eAAe;EACf,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".domino {\n  min-width: 150px;\n  height: 60px;\n  border-radius: 15px;\n  border-width: 2px;\n  border-style: solid;\n  margin: 14px 0px;\n}\n\n.place-domino {\n  background-color: #ededed;\n  border-color: #cacaca;\n}\n\n.place-domino:hover {\n  transform: none;\n}\n\n.some-domino {\n  position: relative;\n\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  overflow: hidden;\n  border-color: #20677b;\n\n  filter: drop-shadow(2px 2px 7px #adadad);\n\n  font-size: 20px;\n  font-family: \"Manrope\";\n  font-weight: bold;\n}\n\n.some-domino-without-hover:hover {\n  transform: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
